import AdminsAside from "./AdminsAside";

const AdminsIndex = () => {
  return (
    <>
      <AdminsAside />
      <h1>Admin Index</h1>
    </>
  );
};

export default AdminsIndex;
